'use client';

import {
  getIsProdEnvironment,
  getIsGhostAccount,
  getIsRunningServerSide,
  getIsMobile,
} from '@/utils/environmentUtils';

export const IS_RUNNING_SERVER_SIDE = getIsRunningServerSide();
export const IS_GHOST_ACCOUNT = getIsGhostAccount();
export const IS_PROD_ENVIRONMENT = getIsProdEnvironment();
export const IS_MOBILE = getIsMobile();

export const APP_TYPE = 'studio';
